import React, { createContext, useState, useCallback } from 'react';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const showNotification = useCallback((message, type = 'info') => {
    const id = Date.now();
    const notification = { id, message, type };

    setNotifications(prev => [...prev, notification]);

    // Auto remove after 5 seconds
    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== id));
    }, 5000);

    return id;
  }, []);

  const removeNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  }, []);

  const showSuccess = useCallback((message) => {
    return showNotification(message, 'success');
  }, [showNotification]);

  const showError = useCallback((message) => {
    return showNotification(message, 'error');
  }, [showNotification]);

  const showWarning = useCallback((message) => {
    return showNotification(message, 'warning');
  }, [showNotification]);

  const showInfo = useCallback((message) => {
    return showNotification(message, 'info');
  }, [showNotification]);

  return (
    <NotificationContext.Provider value={{
      notifications,
      showNotification,
      removeNotification,
      showSuccess,
      showError,
      showWarning,
      showInfo
    }}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationContext;
